<template>
  <div>
    <div class="flex flex-vertical-center">
      <div class="flex-grow flex flex-vertical-center">
        <!-- Address -->
        <sensitive-data-wrapper>
          <p class="property_address">{{ recordTitle }}</p>
        </sensitive-data-wrapper>

        <!-- Deal -->
        <record-deal></record-deal>
      </div>

      <!-- Users -->
      <div class="header_section">
        <template v-if="users.length">
          <app-avatar
            v-for="user in users"
            :key="user.id"
            :user-id="user.id"
            :size="30"
            class="mr-50"
          ></app-avatar>
        </template>
        <template v-else>
          <p class="no_users">No Users</p>
        </template>

        <set-users></set-users>
      </div>

      <!-- Record State -->
      <record-state></record-state>
    </div>
  </div>
</template>

<script>
import SetUsers from "../components/SetUsers";
import RecordState from "../components/RecordState";
import RecordDeal from "../components/RecordDeal";
import utils from "../../../services/utils";
import SensitiveDataWrapper from "../../../components/SensitiveDataWrapper.vue";

export default {
  name: "LeadHeader",
  components: {SensitiveDataWrapper, RecordDeal, RecordState, SetUsers},
  computed: {
    record() {
      // If activeRecord is null then return necessary empty info
      return this.$store.state.activeRecord ? this.$store.state.activeRecord : {
        property: {
          line_1: ''
        },
        userIds: [],
        deal_at: false
      };
    },
    recordTitle() {
      let title = this.record.property.line_1 ? this.record.property.line_1 : 'Unknown Address';

      return utils.truncateString(title, 50);
    },
    users() {
      return this.record.userIds.map(id => {
        return this.$store.getters.users.find(user => user.id === id);
      });
    },
    isDeal: {
      get() {return !!(this.record.record.deal_at)},
      set(val) { this.setDealAt(val) }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.property_address {
  margin-right: 20px;
  font-size: 18px;
  font-weight: bold;
}

.header_section {
  display: flex;
  align-items: center;
  margin-right: 20px;
}

.no_users {
  flex-grow: 1;
  margin-right: 10px;
  color: $text-muted;
}
</style>
